import { createContext } from "react";

export const BannerContext = createContext(true);